import { useEffect, useState } from 'react';
import { services as fallbackServices } from '../data/mock';
import { translations } from '../data/translations';

const KEYS = ['housekeeping', 'frontOffice', 'windowCleaning', 'kitchen'];

// The content that shipped with the site, reshaped to match what the API returns.
// Shown until the API answers, and kept if it never does - so the page is never blank.
export const FALLBACK_SERVICES = fallbackServices.map((s, i) => {
  const tr = (translations.services && translations.services[KEYS[i]]) || {};
  return {
    id: String(s.id),
    title_de: (tr.title && tr.title.de) || s.title,
    title_en: (tr.title && tr.title.en) || s.title,
    subtitle_de: (tr.subtitle && tr.subtitle.de) || s.subtitle || '',
    subtitle_en: (tr.subtitle && tr.subtitle.en) || s.subtitle || '',
    description_de: (tr.description && tr.description.de) || s.description,
    description_en: (tr.description && tr.description.en) || s.description,
    image_url: s.image,
    video_url: s.videoUrl,
    icon: s.icon,
    features_de: [],
    features_en: [],
    order: i,
  };
});

// Reshapes one service into the { key: { de, en } } form the t() helper expects.
export const serviceT = (s) => ({
  title: { de: s.title_de, en: s.title_en },
  subtitle: { de: s.subtitle_de, en: s.subtitle_en },
  description: { de: s.description_de, en: s.description_en },
});

export default function useServices() {
  const [services, setServices] = useState(FALLBACK_SERVICES);

  useEffect(() => {
    let alive = true;
    fetch('/api/cms/services')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((data) => {
        if (alive && Array.isArray(data) && data.length > 0) setServices(data);
      })
      .catch(() => {
        /* keep the built-in content */
      });
    return () => {
      alive = false;
    };
  }, []);

  return services;
}
